// 对http请求进行封装
import axios from 'axios'
import Vue from 'vue'
import { Loading } from 'element-ui'

// const store = require('@/store')

// 使用自定义的配置文件发送请求
const instance = axios.create({
  baseURL: '',
  timeout: 10000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// 添加请求拦截器
instance.interceptors.request.use(function(config) {
  // 在发送请求之前做些什么
  /** 配置全屏加载 */
  if (config.loading !== false) {
    config.loading = Loading.service({
      lock: true,
      background: 'rgba(0, 0, 100%, 0.9)',
      spinner: 'el-icon-loading',
      text: '请稍候...'
    })
  }
  return config
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

/**
 * 关闭全局加载
 * 延迟200毫秒关闭，以免晃眼睛
 * @param target
 */
const closeLoading = (target) => {
  if (!target.config.loading) return true
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      target.config.loading.close()
      resolve()
    }, 100)
  })
}

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
  // 对响应数据做点什么
  if (response.status === 200) {
    closeLoading(response)
    return response.data
  } else {
    console.error('请求错误')
    console.error(response)
  }
  return response
}, function(error) {
  // 对响应错误做点什么
  closeLoading(error)
  // eslint-disable-next-line camelcase
  const error_response = error.response || {}
  // eslint-disable-next-line camelcase
  const error_data = error_response.data || {}
  if (error.config.message !== false) {
    let _message = error.code === 'ECONNABORTED' ? '连接超时，请稍候再试！' : '网络错误，请稍后再试！'
    Vue.prototype.$message.error(error_data.message || _message)
  }
  return Promise.reject(error)
})

// 默认导出  只能有一个默认导出，可以自己起名字，导入时可以不加{}
export default instance



// WEBPACK FOOTER //
// ./src/api/http.js